module.exports = __webpack_public_path__ + "static/img/gong2.1289c26.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logistics/gong2.png
// module id = nVhd
// module chunks = 44